<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="trucksLimit"
				textCreate="Add truck"
				flag="trucks"
				page-title="Trucks"
				:headers="headers"
				:settings="getSettings"
				:filtersList="trucksFilters"
				:list="trucksList"
				:defaultOrder="trucksOrder"
				:defaultSort="trucksSort"

				:totals="trucksTotals"
				:total-pages="trucksTotal"
				:limit-pages="trucksLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				is-create
				:permissionsCreate="permissionsCreate()"
				is-settings
		></main-table-all-back>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('trucks')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>
		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>
		<truck-form
				v-if="isTruckForm"
				:permissions="permissions"
				:id="truckId"
				@updateCloseDialog="onCloseDialog"
		></truck-form>
		<preview-document v-if="previewLink"></preview-document>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
import TruckForm from "@/components/Maintenance/Trucks/TruckForm/TruckForm";
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "Trucks",
	mixins: [ settingsMixins, removeMixins ],
	components: { PreviewDocument, MainTableAllBack, TruckForm },
	computed: mapGetters([
		"trucksList",
		"trucksFilters",
		"trucksTotals",
		"permissions",
		"trucksOrder",
		"trucksLimit",
		"trucksSort",
		"trucksTotal",
		"previewLink",
		"permissionsDefault",
	]),
	data: () => ({
		isTruckForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		truckId: null,
	}),
	methods: {
		...mapActions([
			'getTrucks',
			'getTrucksFilters',
			'actionPreloader',
			'onExportLink', 
			'onTrucksRemoveItem'
		]),

		permissionsCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.MAINTENANCE, PERMISSIONS.TRUCKS, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},

		onCloseDialog(isRefresh) {
			this.isTruckForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},

		async onRemoveItem() {
			const { status } = await this.onTrucksRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			await this.onUpdateFilters(this.defaultFilter);
		},

		async onEvent(flag) {
			if (flag === 'create') {
				this.isTruckForm = true;
				this.truckId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getTrucks(filters);
			if (!isWithoutFilters) await this.getTrucksFilters(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getTrucks(value);
					break;

				case "page":
					await this.onUpdateFilters(value, true); // без filters
					break;

				default:
					await this.onUpdateFilters(value); // ✅ с filters
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'trucks' });
		},

		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.truckId = item.id;
					this.isTruckForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},

		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.truckId = line.id;
				this.isTruckForm = true;
			}
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style scoped lang="scss">

</style>
